import { render, staticRenderFns } from "./UmPd.vue?vue&type=template&id=358fab37&"
import script from "./UmPd.vue?vue&type=script&lang=js&"
export * from "./UmPd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports